import Tenants from 'components/AdministrationTools//Tenants/Tenants';
import NavBar from 'components/NavBar';
import UserContainer from 'components/UserContainer';
import { useAppSelector } from 'hooks/appSelector';
import React, { useState, useEffect } from 'react';
import './style.scss';
import NewUsers from 'components/AdministrationTools/NewUsers/NewUsers';
import RegisteredUsers from 'components/AdministrationTools/RegisteredUsers';
import withAdminCheck from 'HOC/withAdminCheck';
import Charting from 'containers/Charting';
import {
  UserInfo,
  administrationToolsActions,
} from 'actions/administration-tools';

type AdministrationToolsProps = {};

const AdministrationTools: React.FC<AdministrationToolsProps> = () => {
  const user = useAppSelector((state) => state.user);
  const [primaryIsExpanded, setPrimaryIsExpanded] = React.useState<
    boolean | null
  >(null);
  const [modalState, setModalState] = useState<Record<string, boolean>>({
    'Major asset group overview': false,
    Basemaps: true,
    Attributes: false,
    Legend: true,
  });
  const [isPageRendered] = useState(false);
  const [users, setUsers] = useState<UserInfo[] | null>(null);

  const showModal = (title: string) => {
    setModalState((prevState) => ({ ...prevState, [title]: true }));
  };

  const onCloseModal = (title: string) => {
    setModalState((prevState) => ({ ...prevState, [title]: false }));
  };

  useEffect(() => {
    setPrimaryIsExpanded(false);
  }, []);

  useEffect(() => {
    let cancelled = false;

    administrationToolsActions()
      .getUsersInformation()
      .then((response: UserInfo[]) => {
        if (!cancelled) {
          setUsers(response);
        }
      })
      .catch((error: unknown) => {
        console.error('Error loading admin users:', error);
        if (!cancelled) {
          setUsers([]);
        }
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="xa-admin-page">
      {isPageRendered && modalState['Major asset group overview'] && (
        <Charting
          isOpen={modalState['Major asset group overview']}
          closeModal={() => onCloseModal('Major asset group overview')}
        />
      )}
      <NavBar
        displayModal={showModal}
        isExpanded={primaryIsExpanded}
        setIsExpanded={setPrimaryIsExpanded}
        toggleNavBarX={() => setPrimaryIsExpanded(!primaryIsExpanded)}
      />
      <div className="xa-admin-content">
        <Tenants />
        <NewUsers users={users} />
        <RegisteredUsers users={users} />
      </div>
      <UserContainer
        email={user.email}
        firstname={user.firstname}
        surname={user.surname}
      />
    </div>
  );
};

export default withAdminCheck(AdministrationTools);
